var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comptir box is-flex is-justify-content-space-between is-align-items-center"},[_c('h2',[_vm._v(" "+_vm._s(_vm.data.title || _vm.dynamicTitle)+" ")]),_c('b-button',{staticClass:"comptir_btn",attrs:{"tag":"router-link","type":"is-primary","to":{
      name: 'mytrainingitem',
      params: {slug: _vm.training.slug, id: _vm.data.id}
    }}},[_vm._v(" "+_vm._s(_vm.viewLessonButtonText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }